import { DirectoryKey } from "apps/directory/_directoryAppView.config";
import { OperatorWithStatus } from "gql/generated";
import { getMultilingualString, getOperatorStatus } from "shared/utils";

export const useOperatorFilter = () => {
  const filterNotInvited = (data: OperatorWithStatus[], organization: string) =>
    data.filter((item) => getOperatorStatus(item, organization).isNotInvited);

  const filterInvited = (data: OperatorWithStatus[], organization: string) =>
    data.filter((item) => getOperatorStatus(item, organization).isInvited);

  const filterInvitedAccepted = (
    data: OperatorWithStatus[],
    organization: string,
  ) =>
    data.filter(
      (item) => getOperatorStatus(item, organization).isInvitedAccepted,
    );

  const filterNeedsApproval = (data: OperatorWithStatus[]) =>
    data.filter((item) => getOperatorStatus(item).isNeedsApproval);

  const filterApproved = (data: OperatorWithStatus[]) =>
    data.filter((item) => getOperatorStatus(item).isApproved);

  const filterUnpublished = (data: OperatorWithStatus[]) =>
    data.filter((item) => getOperatorStatus(item).isUnpublished);

  const filterSearchValue = (
    data: OperatorWithStatus[],
    searchValue: string,
  ) => {
    return data.filter((item) =>
      getMultilingualString(item.name)
        .toLowerCase()
        .includes(searchValue.toLowerCase()),
    );
  };

  const getFilteredOperators = (
    operators: OperatorWithStatus[],
    key: string,
    organizationId: string = "",
    searchValue?: string,
  ) => {
    let filteredOperators = operators;
    switch (key) {
      case DirectoryKey.All:
        break;
      case DirectoryKey.NotInvited:
        filteredOperators = filterNotInvited(operators, organizationId);
        break;
      case DirectoryKey.Invited:
        filteredOperators = filterInvited(operators, organizationId);
        break;
      case DirectoryKey.InvitedAccepted:
        filteredOperators = filterInvitedAccepted(operators, organizationId);
        break;
      case DirectoryKey.NeedsApproval:
        filteredOperators = filterNeedsApproval(operators);
        break;
      case DirectoryKey.Approved:
        filteredOperators = filterApproved(operators);
        break;
      case DirectoryKey.Unpublished:
        filteredOperators = filterUnpublished(operators);
        break;
      default:
        filteredOperators = [];
    }
    if (searchValue) {
      filteredOperators = filterSearchValue(filteredOperators, searchValue);
    }
    return filteredOperators;
  };

  return {
    filterNotInvited,
    filterInvited,
    filterInvitedAccepted,
    filterNeedsApproval,
    filterApproved,
    filterSearchValue,
    filterUnpublished,
    getFilteredOperators,
  };
};
